/* eslint no-unused-vars : "off" */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Html5QrcodeScanner } from 'html5-qrcode';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import FilePondUpload from 'uploader/FilePondUpload';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function FileUploadModal({
  createInput,
  formData,
  setFormData,
  fileImportUpload,
  updating,
  getfileImportUploadList,
  moduleType,
  subject,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    fileImportUpload(formData, () => {
      setModal({ isOpen: false });
      getfileImportUploadList({ subject });
    });
  };

  const handleOnChange = (data) => {
    setFormData({
      ...formData,
      tag: data,
      subject: moduleType,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const subjectMapper = () => {
    if (subject === 'BIRTH_CERTIFICATE') {
      return 'Year of Birth:';
    }
    if (subject === 'DEATH_CERTIFICATE') {
      return 'Year of Death:';
    }
    return 'Year of Marriage:';
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row mr-2 ml-2">
          <div className="col-12 form-group">
            {createInput(
              {
                key: 'year',
                label: subjectMapper(),
              },
              { required: true, minLength: 4 },
              'form-control-uppercase'
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'volume', label: 'Volume:' },
              { required: true },
              'form-control-uppercase'
            )}
          </div>
          <div className="col-12 form-group">
            <FilePondUpload onChange={handleOnChange} />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  ml-3 "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

FileUploadModal.propTypes = {
  moduleType: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
  getfileImportUploadList: PropTypes.instanceOf(Function).isRequired,
  fileImportUpload: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.CIVIL_REG_FILE_IMPORT_UPLOAD) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(FileUploadModal);
